// HACK: Phase4Step5の終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
// 指摘内容は1ファイルの最大行数（500行）の超過であるため、処理内容自体の問題はないと判断。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import cstmTable from '../../../../share/components/vue/PaginationImgTable';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import error from '../../../../common/nodejs/errors';

// image
const imgHeightMinus = require('@/assets/individualWorkSupport/requirement071/height_minus.png');
const imgHeightPlus = require('@/assets/individualWorkSupport/requirement071/height_plus.png');
const imgPitchMinus = require('@/assets/individualWorkSupport/requirement071/pitch_minus.png');
const imgPitchPlus = require('@/assets/individualWorkSupport/requirement071/pitch_plus.png');
const imgRollMinus = require('@/assets/individualWorkSupport/requirement071/roll_minus.png');
const imgRollPlus = require('@/assets/individualWorkSupport/requirement071/roll_plus.png');
const imgYawMinus = require('@/assets/individualWorkSupport/requirement071/yaw_minus.png');
const imgYawPlus = require('@/assets/individualWorkSupport/requirement071/yaw_plus.png');

/** 各フェーズ定義 */
const PHASE = {
  START: 'start',
  CAMERA_SELECT: 'cameraSelect',
  PARAMETER: 'parameter',
  MAP_GENERATE: 'mapGenerate',
  CONDITIONS_ERROR: 'conditionsError',
  START_ERROR: 'startError',
  STOP_ERROR: 'stopError',
  FAILED: 'failed',
  PARAMETER_ERROR: 'parameterError'
};

/** パラメータ設定 */
const PARAM_CONFIG = {
  YAW: {
    MAX: 50,
    MIN: -50,
    STEP: 1,
  },
  PITCH: {
    MAX: 50,
    MIN: -50,
    STEP: 1,
  },
  ROLL: {
    MAX: 50,
    MIN: -50,
    STEP: 1,
  },
  HEIGHT: {
    MAX: 99,
    MIN: -99,
    STEP: 1,
  },
};

/** 計算種別 */
const MATH_TYPE = {
  ADD: 'add', // +
  SUBTRACT: 'subtract' // -
};

export default {
  name: 'requirement134',
  data() {
    return {
      phase: PHASE.START,
      isLoading: false,
      selectedItemId: null,
      mathButtonDisabled: false,
      inputLimit: false,
      nextProcess: null,
      displayInfo: '',
      systemId: '',
      modalSize: "md",
      selectedCamera: null,
      itemsPhaseUpdate: [],
      columnsPhaseUpdate: [],
      tableParam: {
        yaw: null,
        pitch: null,
        roll: null,
        height: null,
      },
      modal_requirement_134: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  components: {
    'cstm-table': cstmTable
  },

  computed: {
    /** ダイアログのヘッダー色 */
    headerColor() {
      switch (this.phase) {
        case PHASE.CONDITIONS_ERROR:
        case PHASE.START_ERROR:
        case PHASE.STOP_ERROR:
        case PHASE.FAILED:
        case PHASE.PARAMETER_ERROR:
          return 'danger';
        case PHASE.START:
        case PHASE.CAMERA_SELECT:
        case PHASE.PARAMETER:
        case PHASE.MAP_GENERATE:
        default:
          return 'secondary';
      }
    },

    ...mapState({
      language: state => state.systems.language,
      netAppId: state => state.netAppConnector.pairingAppId
    }),

    /** カメラ選択一覧作成処理 */
    cameraList() {
      return [
        { value: 'front', text: this.$t(`individual.row_target_front`) },
        { value: 'left', text: this.$t(`individual.row_target_left`) },
        { value: 'right', text: this.$t(`individual.row_target_right`) },
        { value: 'rear', text: this.$t(`individual.row_target_rear`) }
      ];
    },

    /** パラメータ更新画面のテーブルデータ作成 */
    systemColumnsPhaseUpdate() {
      // 列
      this.columnsPhaseUpdate = [
        {
          name: 'itemName',
          label: 'individual.label_table_item',
          useResource: true
        },
        {
          name: 'itemImageMinus',
          label: 'individual.label_minus',
          useImage: true
        },
        {
          name: 'itemImagePlus',
          label: 'individual.label_plus',
          useImage: true
        },
        {
          name: 'itemValue',
          label: 'individual.label_table_parameter',
        }
      ];

      // データ
      this.createItemsPhaseUpdate();
      return this.columnsPhaseUpdate;
    },
  },

  methods: {

    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.modal_requirement_134 = true;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_134 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      this.isLoading = false;
      // 異常終了：エラー表示
      this.modalSize = "md";
      this.phase = PHASE.FAILED;
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result handler.validate で返ってきたバリデーション結果
    */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック（Vuex の Action を呼びだしている点に注意）
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        // result を使って、任意の処理をすることも可能
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** 次の処理へ遷移 */
    async nextProcessTransition() {
      switch (this.nextProcess) {
        case 'stopError':
          // キャリブレーション処理停止(エラー時)を実行
          await this.executeCalibrationStopError();
          break;
        case 'adjustmentCancelError':
          // 調整値キャンセル処理(エラー時)
          await this.stopAdjustmentCancelError();
          break;
        case 'mapGenerateStop':
          // マップ生成処理停止(正常時)を実行
          await this.stopMapGenerateStop();
          break;
        case 'mapGenerateStopError':
          // マップ生成処理停止(エラー時)を実行
          await this.stopMapGenerateStopError();
          break;
        case 'calibrationVideoOutputStop':
          // キャリブレーション用映像出力停止(正常時)を実行
          await this.executeCalibrationVideoOutputStop();
          break;
        case 'calibrationVideoOutputStopError':
          // キャリブレーション用映像出力停止(エラー時)を実行
          await this.executeCalibrationVideoOutputStopError();
          break;
        case 'exit':
        default:
          // DefaultSession遷移を実行
          await this.exit(0);
          break;
      }
    },

    //----- パラメータ更新画面のテーブルデータ関連 -------------------------------------//
    /** パラメータ更新画面のテーブルデータ作成 */
    createItemsPhaseUpdate() {
      // データ
      this.itemsPhaseUpdate = [
        {
          itemID: 0,
          itemName: 'individual.label_yaw',
          itemImageMinus: imgYawMinus,
          itemImagePlus: imgYawPlus,
          itemValue: this.tableParam.yaw,
        },
        {
          itemID: 1,
          itemName: 'individual.label_pitch',
          itemImageMinus: imgPitchMinus,
          itemImagePlus: imgPitchPlus,
          itemValue: this.tableParam.pitch,
        },
        {
          itemID: 2,
          itemName: 'individual.label_roll',
          itemImageMinus: imgRollMinus,
          itemImagePlus: imgRollPlus,
          itemValue: this.tableParam.roll,
        },
        {
          itemID: 3,
          itemName: 'individual.label_height',
          itemImageMinus: imgHeightMinus,
          itemImagePlus: imgHeightPlus,
          itemValue: this.tableParam.height,
        }
      ];
    },

    //** パラメータ更新画面 テーブル行押下 */
    onUpdateRowClicked(data) {
      if (this.isLoading) {
        return;
      }
      this.selectedItemId = data.itemID;
      this.updateRowHighLight(this.itemsPhaseUpdate);
      this.mathButtonDisabled = true;
    },

    /** テーブル行の強調表示更新 */
    updateRowHighLight(array) {
      array.forEach(item => {
        if (item.itemID === this.selectedItemId) {
          item.fieldSpec = {};
          item.fieldSpec.itemName = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.itemValue = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /** パラメータ更新画面 ＋／－ボタン 押下 */
    async onUpdateChangeValueClicked(type) {
      switch (this.selectedItemId) {
        case 0:
          this.tableParam.yaw = this.updateChangeValue(
            PARAM_CONFIG.YAW, type, this.tableParam.yaw);
          break;
        case 1:
          this.tableParam.pitch = this.updateChangeValue(
            PARAM_CONFIG.PITCH, type, this.tableParam.pitch);
          break;
        case 2:
          this.tableParam.roll = this.updateChangeValue(
            PARAM_CONFIG.ROLL, type, this.tableParam.roll);
          break;
        case 3:
          this.tableParam.height = this.updateChangeValue(
            PARAM_CONFIG.HEIGHT, type, this.tableParam.height);
          break;
        default:
          break;
      }
      if (this.inputLimit) {
        this.inputLimit = false;
        // パラメータ更新書き込み
        await this.writeParameter();
      }
      this.$nextTick(() => {
        this.updateRowHighLight(this.itemsPhaseUpdate);
      });
    },

    /** 値変更操作の反映 */
    updateChangeValue(conf, type, value) {
      let ret = value;
      switch (type) {
        case MATH_TYPE.ADD:
          if (conf.MAX >= (value + conf.STEP)) {
            ret = value + conf.STEP;
            this.inputLimit = true;
          }
          break;
        case MATH_TYPE.SUBTRACT:
          if (conf.MIN <= (value - conf.STEP)) {
            ret = value - conf.STEP;
            this.inputLimit = true;
          }
          break;
        default:
          break;
      }
      return ret;
    },

    //----- バックエンドAPI実行メソッド -----------------------------------------------//
    /**
     * Exit処理
     * @param {*} existence 0:エラー遷移あり, 1:エラー遷移なし 
     * @returns 
     */
    async exit(existence) {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (existence === 0) {
          // エラー遷移あり
          if (response) {
            // 正常コールバック
            switch (response.data.status) {
              case config.STATUS_WSP_COMPLETED:
                // 正常終了：機能終了
                this.closeWizard();
                break;
              case config.STATUS_WSP_FAILED:
              default:
                // 異常終了：共通エラー画面へ遷移
                this.showUnexpectedError();
                return;
            }
          }
        } else {
          // エラー遷移なし：機能終了
          this.closeWizard();
          return;
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** キャリブレーション処理開始 */
    async calibrationStart() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'start'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：キャリブレーション対象カメラ選択画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.CAMERA_SELECT;
              break;
            case config.STATUS_WSP_FAILED:
              // 異常終了
              switch (response.data.async_code) {
                case error.WSP_134_START_PROCESS_ERROR:
                  // 実行条件エラー表示画面でOKボタン押下時にDefaultSession遷移を実行
                  this.nextProcess = 'exit';
                  // 実行条件エラー表示画面へ遷移
                  this.modalSize = "md";
                  this.phase = PHASE.CONDITIONS_ERROR;
                  break;
                default:
                  // 共通エラー画面へ遷移
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** キャリブレーション対象カメラ選択 */
    async executeCalibrationCameraSelect() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute',
            camera: this.selectedCamera
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：パラメータ更新読出し
              await this.readParameterUpdate();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：実行条件エラー表示画面でOKボタン押下時にキャリブレーション処理停止(エラー時)を実行
              this.nextProcess = 'stopError';
              // 実行条件エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.CONDITIONS_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** パラメータ更新読出し */
    async readParameterUpdate() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read',
            camera: this.selectedCamera
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：パラメータ更新画面へ遷移
              this.modalSize = "lg";
              this.selectedItemId = null;
              this.mathButtonDisabled = false;
              this.phase = PHASE.PARAMETER;
              // パラメータ設定
              this.tableParam.yaw = response.data.user_data.calibration_value.yaw;
              this.tableParam.pitch = response.data.user_data.calibration_value.pitch;
              this.tableParam.roll = response.data.user_data.calibration_value.roll;
              this.tableParam.height = response.data.user_data.calibration_value.height;
              // 表生成
              this.$nextTick(() => {
                this.createItemsPhaseUpdate();
              });
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：実行条件エラー表示画面のOKボタン押下時にキャリブレーション用映像出力停止(エラー時)を実行
              this.nextProcess = 'calibrationVideoOutputStopError';
              // 実行条件エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.CONDITIONS_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** マップ生成処理開始／マップ生成状態確認 */
    async executeMapGenerate() {
      try {
        this.phase = PHASE.MAP_GENERATE;
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute-start_map_generation'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              // マップ生成処理停止(正常時)を実行
              await this.stopMapGenerateStop();
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_134_START_PROCESS_ERROR: // ルーチン実行異常終了
                  // 開始処理エラー表示画面のOKボタン押下時にキャリブレーション用映像出力停止(正常時)を実行
                  this.nextProcess = 'calibrationVideoOutputStop';
                  // 開始処理エラー表示読出し
                  await this.readStartError();
                  break;
                case error.WSP_134_CHECK_PROCESS_ERROR: // ルーチン実行正常終了かつルーチン結果確認異常終了
                  // 実行条件エラー表示画面のOKボタン押下時にマップ生成処理停止(エラー時)を実行
                  this.nextProcess = 'mapGenerateStopError';
                  // 実行条件エラー表示画面へ遷移
                  this.modalSize = "md";
                  this.phase = PHASE.CONDITIONS_ERROR;
                  break;
                case error.WSP_134_CHECK_PROCESS_UNEXPECTED_ERROR: // ルーチン実行正常終了かつ実行監視異常終了
                  // 開始処理エラー表示画面のOKボタン押下時にマップ生成処理停止(正常時)を実行
                  this.nextProcess = 'mapGenerateStop';
                  // 開始処理エラー表示読出し
                  await this.readStartError();
                  break;
                default:
                  // 共通エラー画面へ遷移
                  this.showUnexpectedError();
                  break;
              }
              break;
            default: // レスポンスステータスが'Completed','Failed'以外の場合
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 調整値キャンセル処理開始／調整値キャンセル処理状態確認 */
    async executeCancelStart() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'execute-start_value_cancellation'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常時：調整値キャンセル処理(正常時)を実行
              await this.stopAdjustmentCancel();
              break;
            case config.STATUS_WSP_FAILED:
              switch (response.data.async_code) {
                case error.WSP_134_START_PROCESS_ERROR: // ルーチン実行異常終了の場合
                  // 実行条件エラー表示画面のOKボタン押下時にキャリブレーション用映像出力停止(エラー時)
                  this.nextProcess = 'calibrationVideoOutputStopError';
                  // 実行条件エラー表示画面へ遷移
                  this.modalSize = "md";
                  this.phase = PHASE.CONDITIONS_ERROR;
                  break;
                case error.WSP_134_CHECK_PROCESS_ERROR:             // ルーチン結果確認で終了継続以外
                case error.WSP_134_CHECK_PROCESS_UNEXPECTED_ERROR:  // またはルーチン結果確認で異常終了
                  // 実行条件エラー表示画面のOKボタン押下時に調整値キャンセル処理(エラー時)
                  this.nextProcess = 'adjustmentCancelError';
                  // 実行条件エラー表示画面へ遷移
                  this.modalSize = "md";
                  this.phase = PHASE.CONDITIONS_ERROR;
                  break;
                default:
                  // 共通エラー画面へ遷移
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              // 共通エラー画面へ遷移
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** パラメータ更新書込み */
    async writeParameter() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write',
            calibration_value: this.tableParam,
            camera: this.selectedCamera
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：何もしない
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：パラメータ調整エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.PARAMETER_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 開始処理エラー表示読出し */
    async readStartError() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read',
            camera: this.selectedCamera
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了
              switch (response.data.user_data.calibration_value.result) {
                case '00':
                  // 再度キャリブレーションを実施してください。
                  this.displayInfo = this.i18nWsKey + '.label_again_calibration';
                  break;
                case '11':
                  // ドアを閉めてください。
                  this.displayInfo = this.i18nWsKey + '.label_door_close';
                  break;
                case '52':
                  // 再度キャリブレーションを実施してください。
                  // 再実施しても失敗する場合は、カメラECUを交換してください。
                  this.displayInfo = this.i18nWsKey + '.label_re_calibration';
                  break;
                default:
                  // DTCを確認してください。
                  this.displayInfo = this.i18nWsKey + '.label_dtc_confirm';
                  break;
              }
              // 開始処理エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.START_ERROR;
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：実行条件エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.CONDITIONS_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** キャリブレーション処理停止(正常時) */
    async executeCalibrationStop() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'stop-stop_calibration'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：DefaultSession遷移を実行
              await this.exit(0);
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：停止処理エラー表示画面のOKボタン押下時にDefaultSession遷移を実行
              this.nextProcess = 'exit';
              // 停止処理エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.STOP_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** キャリブレーション処理停止(エラー時) */
    async executeCalibrationStopError() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'stop-stop_calibration_on_error'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：DefaultSession遷移を実行
              await this.exit(0);
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：停止処理エラー表示画面のOKボタン押下時にDefaultSession遷移を実行
              this.nextProcess = 'exit';
              // 停止処理エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.STOP_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 調整値キャンセル処理(正常時) */
    async stopAdjustmentCancel() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'stop-value_cancellation'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：キャリブレーション用映像出力停止(正常時)を実行する
              await this.executeCalibrationVideoOutputStop();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 停止処理エラー表示画面のOKボタン押下時に調整値キャンセル処理(エラー時)
              this.nextProcess = 'adjustmentCancelError';
              // 停止処理エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.STOP_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 調整値キャンセル処理(エラー時) */
    async stopAdjustmentCancelError() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'stop-value_cancellation_on_error'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：キャリブレーション用映像出力停止(エラー時)を実行
              await this.executeCalibrationVideoOutputStopError();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 停止処理エラー表示画面でOKボタン押下時にキャリブレーション処理停止(エラー時)を実行
              this.nextProcess = 'calibrationVideoOutputStopError';
              // 停止処理エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.STOP_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** マップ生成処理停止(正常時) */
    async stopMapGenerateStop() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'stop-stop_map_generation'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：キャリブレーション用映像出力停止(正常時)を実行
              await this.executeCalibrationVideoOutputStop();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 停止処理エラー表示画面のOKボタン押下時にキャリブレーション用映像出力停止(エラー時)を実行
              this.nextProcess = 'calibrationVideoOutputStopError';
              // 停止処理エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.STOP_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** マップ生成処理停止(エラー時) */
    async stopMapGenerateStopError() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'stop-stop_map_generation_on_error'
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：キャリブレーション用映像出力停止(エラー時)を実行
              await this.executeCalibrationVideoOutputStopError();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：停止処理エラー表示画面のOKボタン押下時にキャリブレーション用映像出力停止(エラー時)を実行
              this.nextProcess = 'calibrationVideoOutputStopError';
              // 停止処理エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.STOP_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** キャリブレーション用映像出力停止(正常時) */
    async executeCalibrationVideoOutputStop() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'stop-stop_monitoring',
            camera: this.selectedCamera
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：キャリブレーション対象カメラ選択画面へ遷移
              this.selectedCamera = null;
              this.modalSize = "md";
              this.phase = PHASE.CAMERA_SELECT;
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 停止処理エラー表示画面のOKボタン押下時にキャリブレーション処理停止(エラー時)を実行
              this.nextProcess = 'stopError';
              // 停止処理エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.STOP_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** キャリブレーション用映像出力停止(エラー時) */
    async executeCalibrationVideoOutputStopError() {
      try {
        this.isLoading = true;
        //バックエンドAPI POST,GET
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'stop-monitoring_on_error',
            camera: this.selectedCamera
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 正常コールバック
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 正常終了：キャリブレーション処理停止(エラー時)を実行
              await this.executeCalibrationStopError();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了：停止処理エラー表示画面でOKボタン押下時にキャリブレーション処理停止(エラー時)を実行
              this.nextProcess = 'stopError';
              // 停止処理エラー表示画面へ遷移
              this.modalSize = "md";
              this.phase = PHASE.STOP_ERROR;
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },

  async mounted() {
    this.init();
    // キャリブレーション処理開始
    this.calibrationStart();
  },
};